/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedMedicalReportQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedMedicalReportQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    medicalReport?: { __typename?: 'MedicalReport'; url: string; warning?: string | null } | null
  }
}

export const GetAdvancedMedicalReportDocument = gql`
  query getAdvancedMedicalReport($uid: ID!) {
    patient(uid: $uid) {
      medicalReport {
        url
        warning
      }
    }
  }
`

/**
 * __useGetAdvancedMedicalReportQuery__
 *
 * To run a query within a React component, call `useGetAdvancedMedicalReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedMedicalReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedMedicalReportQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedMedicalReportQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdvancedMedicalReportQuery, GetAdvancedMedicalReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedMedicalReportQuery, GetAdvancedMedicalReportQueryVariables>(
    GetAdvancedMedicalReportDocument,
    options
  )
}
export function useGetAdvancedMedicalReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedMedicalReportQuery, GetAdvancedMedicalReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedMedicalReportQuery, GetAdvancedMedicalReportQueryVariables>(
    GetAdvancedMedicalReportDocument,
    options
  )
}
export type GetAdvancedMedicalReportQueryHookResult = ReturnType<typeof useGetAdvancedMedicalReportQuery>
export type GetAdvancedMedicalReportLazyQueryHookResult = ReturnType<typeof useGetAdvancedMedicalReportLazyQuery>
export type GetAdvancedMedicalReportQueryResult = Apollo.QueryResult<
  GetAdvancedMedicalReportQuery,
  GetAdvancedMedicalReportQueryVariables
>
